// initial state
// shape: [{ id, quantity }]
const state = {
  userOptions: [],
}

// getters
const getters = {
  // demoTable: state => state.table
}

// actions
const actions = {
  getTekeOrderTable ({commit, state}, params) {
    let promised = request.alert('getTekeOrderTable', params)
    return promised
  },
  batchCompleteTekeOrder ({commit, state}, params) {
    let promised = request.alert('batchCompleteTekeOrder', params)
    return promised
  },
  batchCancelTekeOrder ({commit, state}, params) {
    let promised = request.alert('batchCancelTekeOrder', params)
    return promised
  },
  reviewTekeOrderPass ({commit, state}, params) {
    let promised = request.alert('reviewTekeOrderPass', params)
    return promised
  },
}

// mutations
const mutations = {}

export const tekeOrder = {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/teke-order/tekeOrder.store.js